import React from "react";
import { GqlModule, ModulesContextInterface } from "types/module";

export const ModulesContext = React.createContext<ModulesContextInterface>({
  modules: [],
  setModules: (_modules: GqlModule[]) => {},
});
